/* Shade Finder — tab switching, variant selection, AJAX add-to-cart. */
(function () {
  'use strict';

  function cartAddUrl() {
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    return root.replace(/\/$/, '') + '/cart/add.js';
  }

  function cartUrl() {
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    return root.replace(/\/$/, '') + '/cart';
  }

  function initRoot(root) {
    if (root.dataset.sfInit === '1') return;
    root.dataset.sfInit = '1';

    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-sf-tab]'));
    var swatches = Array.prototype.slice.call(root.querySelectorAll('[data-sf-variant]'));
    var idInput = root.querySelector('[data-sf-id]');
    var cta = root.querySelector('[data-sf-cta]');
    var priceEl = cta ? cta.querySelector('[data-sf-price]') : null;
    var addBtn = root.querySelector('[data-sf-add]');
    var addText = root.querySelector('[data-sf-add-text]');
    var form = root.querySelector('.shade-finder__form');

    if (!swatches.length || !idInput || !addBtn) return;

    var addLabel = (cta && cta.dataset.sfAddLabel) || 'Add to cart';
    var addedLabel = (cta && cta.dataset.sfAddedLabel) || 'Added!';
    var soldoutLabel = (cta && cta.dataset.sfSoldoutLabel) || 'Sold out';
    var useAjax = cta && cta.dataset.sfAjax === 'true';
    var redirect = cta && cta.dataset.sfRedirect === 'true';

    function selectSwatch(btn) {
      if (!btn || btn.dataset.sfSoldout === 'true') {
        // still update CTA state so a fully sold-out group reads correctly
      }
      swatches.forEach(function (s) {
        var on = s === btn;
        s.classList.toggle('is-selected', on);
        s.setAttribute('aria-pressed', on ? 'true' : 'false');
      });

      idInput.value = btn.getAttribute('data-sf-variant');

      if (priceEl && btn.dataset.sfPrice) {
        priceEl.textContent = btn.dataset.sfPrice;
      }

      var available = btn.getAttribute('data-sf-available') === 'true';
      if (available) {
        addBtn.removeAttribute('disabled');
        if (addText) addText.textContent = addLabel;
      } else {
        addBtn.setAttribute('disabled', '');
        if (addText) addText.textContent = soldoutLabel;
      }
    }

    function firstSelectable(groupKey) {
      var inGroup = swatches.filter(function (s) {
        return s.getAttribute('data-sf-group') === groupKey;
      });
      var available = inGroup.filter(function (s) {
        return s.dataset.sfSoldout !== 'true';
      });
      return available[0] || inGroup[0] || null;
    }

    function selectTab(groupKey) {
      tabs.forEach(function (t) {
        var on = t.getAttribute('data-sf-tab') === groupKey;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
      });

      swatches.forEach(function (s) {
        var show = s.getAttribute('data-sf-group') === groupKey;
        if (show) {
          s.removeAttribute('hidden');
        } else {
          s.setAttribute('hidden', '');
        }
      });

      selectSwatch(firstSelectable(groupKey));
    }

    /* Tab events */
    tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function () {
        selectTab(tab.getAttribute('data-sf-tab'));
      });
      tab.addEventListener('keydown', function (e) {
        var dir = 0;
        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') dir = 1;
        else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') dir = -1;
        else return;
        e.preventDefault();
        var next = (i + dir + tabs.length) % tabs.length;
        tabs[next].focus();
        selectTab(tabs[next].getAttribute('data-sf-tab'));
      });
    });

    /* Swatch events */
    swatches.forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.dataset.sfSoldout === 'true') return;
        selectSwatch(btn);
      });
    });

    /* Add to cart */
    if (form) {
      form.addEventListener('submit', function (e) {
        if (!useAjax) return; // native POST fallback
        if (addBtn.hasAttribute('disabled')) {
          e.preventDefault();
          return;
        }
        e.preventDefault();

        var prev = addText ? addText.textContent : '';
        addBtn.classList.add('is-loading');
        addBtn.setAttribute('disabled', '');

        fetch(cartAddUrl(), {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify({
            items: [{ id: Number(idInput.value), quantity: 1 }]
          })
        })
          .then(function (r) {
            return r.json().then(function (data) {
              return { ok: r.ok, data: data };
            });
          })
          .then(function (res) {
            addBtn.classList.remove('is-loading');
            if (!res.ok) {
              addBtn.removeAttribute('disabled');
              if (addText) addText.textContent = prev;
              return;
            }

            if (redirect) {
              window.location = cartUrl();
              return;
            }

            if (addText) addText.textContent = addedLabel;

            // Notify the theme (covers common cart-drawer implementations).
            document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
            document.dispatchEvent(new CustomEvent('cart:build'));
            document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
            if (window.PUB_SUB_EVENTS && typeof window.publish === 'function') {
              window.publish(window.PUB_SUB_EVENTS.cartUpdate, {
                source: 'shade-finder',
                productVariantId: idInput.value
              });
            }

            setTimeout(function () {
              addBtn.removeAttribute('disabled');
              if (addText) addText.textContent = addLabel;
            }, 1800);
          })
          .catch(function () {
            addBtn.classList.remove('is-loading');
            addBtn.removeAttribute('disabled');
            if (addText) addText.textContent = prev;
          });
      });
    }
  }

  function initAll() {
    document.querySelectorAll('[data-sf-root]').forEach(initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  /* Shopify theme editor support */
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-sf-root]');
    if (root) initRoot(root);
  });
})();
